import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import {
  ComponentLayouts,
  StoryblokRendererV2 as StoryblokRenderer,
} from '@cinch-nx/storyblok-utils'
import { DeliveryProps } from './get-static-props'
import { storyblokComponentsDelivery } from './storyblok/data/storyblok-renderer-map'
import { DeliveryStory } from './storyblok/storyblok'

export const Delivery = ({ story, preview }: DeliveryProps) => {
  const { content } = useStoryblokState<DeliveryStory>({
    story,
    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}

  const {
    PreFooterCtaV2,
    SectionWithImageV2,
    LandingTextInlineImageSection,
    FeatureCardRowWrapper,
    ...remainingComponents
  } = storyblokComponentsDelivery

  const componentLayouts: ComponentLayouts = {
    fullWidthWrapper: {
      PreFooterCtaV2,
      SectionWithImageV2,
      LandingTextInlineImageSection,
      FeatureCardRowWrapper,
    },
    slimWrapper: remainingComponents,
  }

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="Home delivery - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />
      <article>
        <StoryblokRenderer block={content.body} components={componentLayouts} />
      </article>
    </>
  )
}
